module.exports = __webpack_public_path__ + "static/SAMSUNG_clip-36f633f36e2d6f83a62d6f627681101b.mp4";